import { createContext } from 'react';
/**
 * Create the React Context
 */

export var DndContext = createContext({
  dragDropManager: undefined
});